import { useQuery, useQueryClient } from 'react-query';
import { ITableHeaders } from 'shared/components/Table/Table';
import { reportService } from 'shared/services/ReportsService';

interface IUseSigmaReportParams {
    year: number;
    organization: number;
    facility: number;
    code: number;
    headers: ITableHeaders[];
}

export const useSigmaReport = (params: IUseSigmaReportParams) => {
    const queryClient = useQueryClient();

    const { data, isLoading, isError, refetch } = useQuery(
        [
            'sigma-report',
            params.code,
            params.facility,
            params.organization,
            params.year,
            `${params.headers.filter((header) => header.selected)[0]?.title}=${
                params.headers.filter((header) => header.selected)[0]?.sortable
            }`,
        ],
        () => {
            let queryParams: any = {};

            params.headers.forEach((header) => {
                if (header.selected) {
                    switch (header.title) {
                        case 'Year':
                            queryParams = {
                                'order[year]': header.sortable,
                            };
                            break;

                        default:
                            break;
                    }
                }
            });

            if (params?.year) {
                queryParams['year'] = params.year;
            }

            if (params?.organization) {
                queryParams['procedure.facility.organization.id'] =
                    params.organization;
            }
            if (params?.facility) {
                queryParams['procedure.facility.id'] = params.facility;
            }
            if (params?.code) {
                queryParams['procedure.condition.id'] =
                    params.code;
            }

            return reportService.getSigmaReport(queryParams);
        },
        {
            onError: (error: Error) => {
                console.log('Error on getting student - ', error);
            },
            initialData: () =>
                queryClient.getQueryData([
                    'standard-report',
                    params.code,
                    params.facility,
                    params.organization,
                    params.year,

                    `${
                        params.headers.filter((header) => header.selected)[0]
                            ?.title
                    }=${
                        params.headers.filter((header) => header.selected)[0]
                            ?.sortable
                    }`,
                ]),
            // staleTime: TimeDurationEnum.HOUR,
            // cacheTime: 0,
        }
    );

    return {
        data,
        isLoading,
        serverErrorMessage: isError,
        refetch,
    };
};
